






































import { PatientStatusChangeRequested } from '@/+state/patient-details/events';
import {
  patientDetailStatus,
  customErrorMessage,
  statusLoading,
} from '@/+state/patient-details/projections';
import { emit, select } from '@conversa/reflex';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  setup(_, ctx) {
    const optedOut = select(patientDetailStatus).value;
    const dialogInfo = optedOut
      ? {
          title: 'Opt Patient In?',
          description:
            'Would you like to Opt the patient In? Opting the patient in will restart the chat schedule for enrolled programs. Recalcuation of the schedule will be processed overnight. If you would like to recalculate the schedule immediately you will need to unenroll then reenroll them from any programs.',
          button: 'Opt Patient In',
          loading: 'Opting Patient In...',
          color: '#4ba6dd',
        }
      : {
          title: 'Opt Patient Out?',
          description:
            'Would you like to Opt the patient Out? Opting the patient Out will stop all chat notifications and will remove any scheduled chats for enrolled programs but will not unenroll them from any programs.',
          button: 'Opt Patient Out',
          loading: 'Opting Patient Out...',
          color: '#D93B3D',
        };

    return {
      dialogInfo,
      optedOut,
      errorMessage: select(customErrorMessage),
      loading: select(statusLoading),
      cancel: () => ctx.emit('dialog-closed'),
      updateStatus: () =>
        emit(PatientStatusChangeRequested({ optedOut: !optedOut })),
    };
  },
});
